import type { Translations } from '@bynder/localization';

// The cast papers over a shape mismatch that predates this file being
// typechecked: `import()` of a JSON module resolves to `{ default: {...} }`,
// while `LocalizationProvider` types `fetchFallback` as resolving to the flat
// key map. Runtime behaviour is left exactly as it was.
function fetchFallback(): Promise<Translations> {
    return import(
        /* webpackChunkName: "locales" */
        /* webpackPreload: true */
        '../../locales/en_US.json'
    ) as unknown as Promise<Translations>;
}

export default fetchFallback;
